/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockUpdateBase } from './StockUpdateBase';
import {
    StockUpdateBaseFromJSON,
    StockUpdateBaseFromJSONTyped,
    StockUpdateBaseToJSON,
    StockUpdateBaseToJSONTyped,
} from './StockUpdateBase';

/**
 * 
 * @export
 * @interface StockUpdate
 */
export interface StockUpdate {
    /**
     * 
     * @type {Array<StockUpdateBase>}
     * @memberof StockUpdate
     */
    body: Array<StockUpdateBase>;
}

/**
 * Check if a given object implements the StockUpdate interface.
 */
export function instanceOfStockUpdate(value: object): value is StockUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function StockUpdateFromJSON(json: any): StockUpdate {
    return StockUpdateFromJSONTyped(json, false);
}

export function StockUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(StockUpdateBaseFromJSON)),
    };
}

export function StockUpdateToJSON(json: any): StockUpdate {
    return StockUpdateToJSONTyped(json, false);
}

export function StockUpdateToJSONTyped(value?: StockUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(StockUpdateBaseToJSON)),
    };
}

